(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6434],{

/***/ 72084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ TickFill; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function TickFill(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 29.25,
        height: props.height || 29.25,
        viewBox: "0 0 29.25 29.25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.625 0A14.625 14.625 0 1029.25 14.625 14.623 14.623 0 0014.625 0zm7.488 10.582l-9.4 9.443h-.008a1.27 1.27 0 01-.816.387 1.231 1.231 0 01-.823-.4l-3.941-3.939a.28.28 0 010-.4l1.256-1.248a.272.272 0 01.394 0l3.122 3.122 8.578-8.641a.278.278 0 01.2-.084.255.255 0 01.2.084l1.23 1.273a.277.277 0 01.008.403z",
            fill: props.color || "#000000"
        })
    }));
}


/***/ }),

/***/ 65700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var LoaderIcon = function(props) {
    var waterSplashLoader = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "waterSplashLoader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var ellipsis = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "ds-ellipsis-loader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var _renderLoader = function(type) {
        switch(type){
            case "water_splash_loader":
                return waterSplashLoader();
            case "ellipsis":
            default:
                return ellipsis();
        }
    };
    return _renderLoader(props.type || "");
};
/* harmony default export */ __webpack_exports__["Z"] = (LoaderIcon);


/***/ }),

/***/ 79220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GlobalCfeLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _globalLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25480);


var GlobalCfeLoader = function(param) {
    var type = param.type, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_globalLoader__WEBPACK_IMPORTED_MODULE_1__/* .GlobalLoader */ .k, {
        type: type,
        color: color
    });
};


/***/ }),

/***/ 25480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GlobalLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85134);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98388);
/* harmony import */ var src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26706);
/* harmony import */ var src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65700);







var GlobalLoader = function(props) {
    var type = props.type, color = props.color;
    var store = (0,src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.documentElement.style.setProperty("--loader-color", color);
    }, [
        color
    ]);
    switch(type){
        case "logo1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo1)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "logo2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo2)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "loader1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    version: "1.1",
                    id: "L9",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "65px",
                    height: "65px",
                    viewBox: "0 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: color,
                        d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            dur: "1s",
                            from: "0 50 50",
                            to: "360 50 50",
                            repeatCount: "indefinite"
                        })
                    })
                });
            }
        case "loader2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L5",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 15 ; 0 -15; 0 15",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "30",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 10 ; 0 -10; 0 10",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "54",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader3":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader3), "tw-h-[35px] tw-w-[35px]")
                });
            }
        case "loader4":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L4",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "26",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "46",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader5":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader5), "tw-h-[16px] tw-w-[35px]")
                });
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
            }
    }
};


/***/ }),

/***/ 71778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/*
  Returns isComponentMounted
  isComponentMounted -> true / Component is Successfully mounted
*/ function useIsComponentMounted() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isComponentMounted = ref[0], setIsComponentMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsComponentMounted(true);
    }, []);
    return isComponentMounted;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsComponentMounted);


/***/ }),

/***/ 85134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo1":"globalLoader_logo1__U4pxQ","logo-1":"globalLoader_logo-1__07zYZ","logo2":"globalLoader_logo2__eivVl","loader-3":"globalLoader_loader-3__8hklP","loader3":"globalLoader_loader3__m47Bj","loader5":"globalLoader_loader5__6NXRf","loader-5-1":"globalLoader_loader-5-1__pESNT","loader-5-2":"globalLoader_loader-5-2__VgxuZ"};

/***/ })

}]);